import React, { Dispatch, SetStateAction } from "react";
import "./GallerySortBy.scss";

import CustomSelect from "src/app/components/CustomSelect/CustomSelect";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { CustomSelectOption } from "src/types";
import { GallerySortByKey, gallerySortByOptions } from "./utils";

interface Props {
  sortBy: CustomSelectOption<GallerySortByKey>;
  setSortBy: Dispatch<SetStateAction<CustomSelectOption<GallerySortByKey>>>;
}

export default function GallerySortBy(props: Props) {
  const { sortBy, setSortBy } = props;

  return (
    <div className="gallery-sort-by">
      <IDHFormattedMessage id="ws_sort_by" defaultMessage="Sort by" />
      <CustomSelect
        value={sortBy}
        options={gallerySortByOptions}
        onChange={setSortBy}
        data-qa="sort-by-select"
        placeholder={
          <>
            <IDHFormattedMessage id="ws_select" defaultMessage="Select" />
            ...
          </>
        }
      />
    </div>
  );
}
